export default {
	liveCardCheck:'点击查看',
	prefix: '/',
	home: '首页',
	tel: '电话',
	email: '邮箱',
	more: '更多',
	share: '分享',
	dicKey: 'label',
	enumKey: 'label',
	submit: '提交',
	cancel: '取消',
	confirm: '确认',
	language: '语言',
	location: '您的位置',
	welcome: '欢迎参加第五届国际商事法律合作论坛',
	welcomeNoTime:'国际商事法律合作论坛',
	introduce:'详细介绍',
	aboutUs: '关于我们',
	previousForums:'往届论坛',
	privacy: '用户隐私和服务条款',
	aboutForum: '关于论坛',
	contactUs: '联系我们',
	enterRoom: '进入直播间',
	watchNow: '立即观看',
	loadMore: '加载更多',
	enrollNow: '线上直播报名',
	views: '访问量',
	backTop:'返回顶部',
	videoViewNumber:'人观看',
	successUpload:'上传成功!',
	uploadImgError:'请上传正确的格式图片',
	uploadImgSizeError:'图片最大不能超过  2M!',
	countdown: {
		still: '距开始还有',
		title: '距论坛开幕还有',
		watchNow: '观看论坛直播',
		OfficiallyOpened:'正式开幕',
		Countdown:'开幕式倒计时',
		liveTime: '直播时间',
		opening: '第五届国际商事法律合作论坛',
		format: {
			day: '天',
			hour: '时',
			minute: '分',
			second: '秒',
			text: '天时分秒'
		}
	},
	im: {
		send: '发送',
		header: '聚全球之商事、论天下之法治',
		placeholder: '请输入您的内容....'
	},
	actionSide: {
		chat: '在线咨询',
		enrollNow: '线上直播报名',
		offlineEnrollNow: '线下参会报名',
		onlineSide:"线上直播报名入口",
		offlineSide:"线下参会报名入口",
		feedback: '投诉建议',
		contactUs: '联系我们',
		applyPath:'/apply'
	},
	qrcode: {
		lawback: '涉外法律服务平台<br/>官方公众号',
		ICLCF: '国际商事法律合作<br/>论坛官方公众号'
	},
	interview: {
		all: '全部',
		latest: '最新',
		text: '专家访谈'
	},
	live: {
		all: '所有直播',
		time: '时间',
		back: '返回列表',
		agenda: '直播议程',
		replay: '可回放',
		conference: '大会直播',
		introduction: '介绍',
		over: '直播已结束',
		views: '观看人次',
		viewLive:'观看直播',
		clickLive:'进入直播间',
		wait: '直播即将开始<br/>敬请期待...',
		'chat':'互动',
		'guest':'嘉宾介绍',
		'forbiddenTime':'您已经被禁言5分钟',
		'hasForbidden':'您已被禁言',
		'talk':'来说两句吧...',
		'youAreDisabled':'您已被禁言，暂不能发送消息',
		'enterWord':'输入你想说的话~',
		'send':'发送',
		'remindTime':'距直播仅剩',
		'applyNum':'预约人数',
		'watchNum':'观看人次',
		'proTalk':'专家访谈',
		'lookMore':'查看更多',
		'forbid':'禁言5分钟',
		'forbidEver':'禁言到直播结束',
		'unForbid':'解除禁言',
		'liveEnd':'直播已结束',
		'remove':'删除',
		"flash":"请使用flash播放器",
		"willStart":"请耐心等待，直播马上开始",
		"netError":"网络异常",
		"apply":"线上直播报名",
		"d":'天',
		"h":'时',
		"m":'分',
		"s":'秒'
	},
	guest: {
		all: '全部嘉宾',
		ranking: '排名不分先后',
		introduction: '嘉宾介绍'
	},
	agenda: {
		am: '上午议程',
		pm: '下午议程',
		all: '全部会议',
		text: '论坛议程',
		expand: '查看嘉宾',
		collapse: '收起'
	},
	news: {
		tag: '标签',
		hot: '热门资讯',
		allNews:'全部资讯',
		category: '分类',
		latest: '最新动态',
		recommend: '推荐',
		views: '阅读量'
	},
	video: {
		outline: '视频大纲',
		content: '视频简介',
		recommend: '相关视频',
		expert: '专家介绍',
		copyright: '版权声明：本内容系视频独家，未经授权，不得转载',
		PastVideo:'往届精彩回顾',
		LectureTour:'线下巡回论坛',
		Introduction:'内容介绍'
	},
	links: {
		text: '特别鸣谢',
		ranking: '排名不分先后',
		recommendation:'项目推荐',
		supplier:'优质供应商',
		supplierRec:'优质供应商推荐',
		publisher:'发布者'
	},
	search: {
		text: '搜索',
		latest: '最新动态',
		guest: '嘉宾',
		video: '专家访谈',
		agenda: '议程',
		placeholder: '请输入搜索内容',
		noResult: '未搜索到相关结果，建议您修改关键词后重新再试',
		searchNull:'未搜索到相关结果，建议您修改关键词后重新再试'
	},
	comment: {
		top: '顶',
		send: '发布',
		text: '互动',
		all: '全部互动',
		none: '暂无互动',
		placeholder: '说点什么吧...'
	},
	login: {
		btn: '登录',
		path: '/login',
		text: '欢迎来到国际商事法律合作论坛',
		submit: '登录',
		rememberMe: '记住登陆状态',
		verifyAlert:'验证码已发送',
		Logout:'退出登录',
		agreement: '点击登录或完成账号注册表示您已阅读并同意<br><a href="/privacy" style="color: rgba(5,120,186,1);">《用户服务协议》</a>和<a href="/privacy" style="color: rgba(5,120,186,1);">《隐私条款》</a>',
		tabs: [
			{
			key: 'password',
			tab: '密码登录',
			type: 'login',
			active: true,
			rules: ['username', 'password'],
			inputs: ['username', 'password']
		},
			{
			key: 'captcha',
			tab: '验证码登录',
			type: 'login',
			rules: ['username', 'code'],
			inputs: ['username', 'code']
		},
			{
			key: 'mobile',
			tab: '手机号注册',
			type: 'signup',
			active: true,
			rules: ['phone', 'code', 'password'],
			inputs: ['phone', 'code', 'password', 'actualName', 'company', 'email']
		}, {
			key: 'email',
			tab: '邮箱注册',
			type: 'signup',
			rules: ['email', 'code', 'password'],
			inputs: ['email', 'code', 'password', 'actualName', 'company', 'phone']
		}, {
			key: 'mobile',
			tab: '手机号找回',
			type: 'forget',
			active: true,
			rules: ['phone', 'code', 'password'],
			inputs: ['phone', 'code', 'password']
		}, {
			key: 'email',
			tab: '邮箱找回',
			type: 'forget',
			rules: ['phone', 'code', 'password'],
			inputs: ['email', 'code', 'password']
		}],
		rules: {
			username: [{required: true, whitespace: true, message: '请输入手机号或邮箱'}],
			phone: [{required: true, whitespace: true, pattern: /^((?!@).)*$/, message: '请输入合法的手机号'}],
			email: [{required: true, whitespace: true, pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '请输入合法的邮箱'}],
			code: [{required: true, whitespace: true, message: '请输入验证码'}],
			password: [{required: true, message: '请输入密码'}],
			actualName: [{required: true, whitespace: true, message: '请输入姓名'}],
			company: [{required: true, whitespace: true, message: '请输入企业名称'}]
		},
		inputs: {
			username: {icon: 'mobile', type: 'a-input', placeholder: '请输入手机号或邮箱'},
			phone: {icon: 'mobile', type: 'a-input', placeholder: '请输入手机号'},
			email: {icon: 'mail', type: 'a-input', placeholder: '请输入邮箱'},
			code: {icon: 'safety', type: 'a-input', placeholder: '请输入验证码', append: {text: '发送验证码'}},
			password: {icon: 'lock', type: 'a-input-password', placeholder: '请输入密码'},
			actualName: {icon: 'user', type: 'a-input', placeholder: '请输入姓名'},
			company: {icon: 'bank', type: 'a-input', placeholder: '请输入企业名称(选填)'},
			phoneEmail:{error:'请输入正确的邮箱或手机号'}
		}
	},
	forget: {
		text: '忘记密码',
		remember: '记得密码？去登录'
	},
	signup: {
		text: '注册账号',
		expand: '更多信息',
		collapse: '收起更多信息',
		hasAccount: '已有账户？去登录'
	},
	logout: {
		title: '退出登录',
		content: '您确认退出登录？'
	},
	profile: {
		btn: '我的',
		path: '/profile',
		profile: {
			tab: '个人资料',
			mobile: '手机号码',
			company: '所属企业',
			email: '我的邮箱',
			setPwd: '设置密码',
			changePwd: '修改密码',
			logout: '退出登录'
		},
		message: '我的消息',
		appointment: {
			tab: '我的预约',
			no: '预约单号',
			guest: '预约嘉宾',
			time: '预约时间',
			tools: '沟通方式',
			content: '内容',
			duration: '沟通时长',
			talkType: '洽谈类型',
			company: '单位',
			position: '职位',
			enterpriseScale: '企业规模'
		}
	},
	appointment: {
		btn: '预约',
		title: '预约洽谈',
		message: '提交成功，请耐心等待，工作人员将在1-3个工作日内与您联系，请您保持手机畅通！',
		fields: {
			content: {
				label: '洽谈内容',
				help: '最多1024个字符',
				placeholder: '请输入洽谈内容'
			},
			utc: '世界时间',
			time: '预约时间',
			way: {
				label: '方式'
			},
			contact: {
				label: '联系方式',
				placeholder: '请输入联系方式'
			},
			talkType: '洽谈类型',
			company: {
				label: '单位',
				placeholder: '请输入单位名称'
			},
			position: {
				label: '职位',
				placeholder: '请输入职位名称'
			},
			enterpriseScale: '企业规模',
			submit: '提交'
		},
		rules: {
			way: [{required: true, message: '请选择沟通方式'}],
			time: [{required: true, message: '请选择预约时间'}],
			contact: [{required: true, whitespace: true, message: '请输入联系方式'}],
			content: [{required: true, whitespace: true, message: '请输入洽谈内容'}],
			company: [{required: true, whitespace: true, message: '请输入单位名称'}],
			position: [{required: true, whitespace: true, message: '请输入职位名称'}]
		}
	},
	enroll: {
		text: '国际商事法律论坛报名',
		message: '报名成功',
		inputs: {
			inviterId: {
				label: '邀请方',
				type: 'a-select',
				placeholder: '请选择邀请方',
				rules: [{required: true, message: '请选择邀请方'}]
			},
			attendee: {
				label: '参会者',
				type: 'a-select',
				placeholder: '请选择参与者',
				rules: [{required: true, message: '请选择参与者'}]
			},
			company: {
				label: '企业名称',
				type: 'a-input',
				placeholder: '请输入企业名称',
				rules: [{required: true, whitespace: true, message: '请输入企业名称'}]
			},
			name: {
				label: '姓名',
				type: 'a-input',
				placeholder: '请输入姓名',
				rules: [{required: true, whitespace: true, message: '请输入姓名'}]
			},
			position: {
				label: '职位',
				type: 'a-input',
				placeholder: '请输入职位',
				rules: [{required: true, whitespace: true, message: '请输入职位'}]
			},
			email: {
				label: '邮箱',
				type: 'a-input',
				placeholder: '请输入邮箱',
				rules: [{required: true, whitespace: true, message: '请输入邮箱'}]
			},
			mobile: {
				label: '手机号码',
				type: 'a-input',
				placeholder: '请输入手机号码',
				rules: [{required: true, whitespace: true, message: '请输入手机号码'}]
			}
		}
	},
	feedback: {
		text: '意见反馈',
		message: '提交成功，感谢您的反馈',
		inputs: {
			name: {
				label: '姓名',
				type: 'a-input',
				placeholder: '请输入姓名',
				rules: [{required: true, whitespace: true, message: '请输入姓名'}]
			},
			mobile: {
				label: '手机号码',
				type: 'a-input',
				placeholder: '请输入手机号码',
				rules: [{required: true, whitespace: true, message: '请输入手机号码'}]
			},
			content: {
				label: '反馈内容',
				type: 'a-textarea',
				placeholder: '请输入反馈内容',
				help: '最多200个字符',
				rules: [{required: true, whitespace: true, message: '请输入反馈内容'}]
			}
		}
	},
	footer: {
		email: '联系邮箱',
		support: '服务平台：<a href="https://www.lawback.com/" target="_blank">律回网</a>',
		suggest: '建议使用Chrome或ie9及以上浏览器和1280*1024以上的分辨率,以获得最佳浏览效果。',
		links: [{
			text: '关于论坛',
			path: '/about'
		}, {
			text: '联系我们',
			path: '/contact'
		},
		// 	{
		// 	text: '友情链接',
		// 	path: '/links?types=1,2'
		// },
			{
			text: '隐私条款',
			path: '/privacy'
		}],
		relation:['服务热线','0731-88665003 / 010-82217083','联系邮箱','ccpit_2021@163.com'],
		erwei1:'国际商事法律合作论坛官方公众号',
		erwei2:'涉外法律服务平台官方公众号'
	},
	searchTabs:['大会直播','发言嘉宾','专家访谈','精彩回顾','资讯内容','主承办单位'],
	offlineApply:{		
		lastStep:'上一步',
		nextStep:'下一步',
		confirm:'确定',
		getBack:'返回修改',
		submit:'提交',
		applyPlan:['个人信息','机构信息','联系信息'],
		baomingxinxitianxie: '报名信息填写',
		gerenxinxi:'个人信息',
		jigouxinxi:'机构信息',
		lianxixinxi:'联系信息',
		leixing:'类型',
		nameCn:'姓名 (中文)',
		nameEn:'姓名 (英文)',
		qianfaguojia:'签发国家或地区',
		shenfenzhengleixing:'身份证件类型',
		zhengjianhaoma:'证件号码',
		chushengriqi:'出生日期',
		sex:'性别',
		chengwei:'称谓',
		touxiang:'头像上传',
		zhengjianshangchuan:'证件上传',
		qingxuanze:'请选择',
		nameEnPlaceholder:'请输入英文名称',
		nameCnPlaceholder:'请输入中文名称',
		zhengjianPlaceholder:'请输入证件号码',
		leixingRules:'请选择类型',
		qianfaguojiaRules:'请选择签发国家或地区',
		shenfenzhengleixingRules:'请选择身份证件类型',
		chushengriqiRules:'请选择出生日期',
		sexRules:'请选择性别',
		chengweiRules:'请选择称谓',
		zhengjianhaomaRules:'请输入证件号码',
		ImageUploadHint:{
			p1:'上传电子版照片为近期免冠正面证件照,格式为png/jpg/jpeg',
			p2:'不大于2M、分辨率500px宽*800px高',
			p3:'不要将其他格式的图片直接修改文件的扩展名上传',
			p4:'保证照片清晰度',
			rules:'请上传头像'
		},
		CertificateUploadHint:{
			p1:'上传证件照片或证件附件,格式为png/jpg/jpeg/pdf',
			p2:'不大于2M',
			p3:'不要将其他格式的图片直接修改文件的扩展名上传',
			p4:'保证照片清晰度',
			rules:'请上传证件'
		},
		hangye:'所属行业',
		jigouEn:'机构全称 (英文)',
		zhiwuCn:'职务 (中文)',
		jigoujianchengCn:'机构简称 (中文)',
		jigouCn:'机构全称 (中文)',
		jigoudizhi:'机构地址',
		zhiwuEn:'职务 (英文)',
		jigoujianchengEn:'机构简称 (英文)',
		jigouCnRules:'请输入中文机构全称',
		jigouEnRules:'请输入英文机构全称',
		jigoujianchengCnRulesNull:'请输入中文机构简称',
		jigoujianchengEnRulesNull:'请输入英文机构简称',
		jigoudizhiRules:'请输入机构地址',
		zhiwuCnRules:'请输入中文职务',
		zhiwuEnRules:'请输入英文职务',
		jigoujianchengCnRules:'最多8个文字',
		jigoujianchengEnRules:'最多20个字母包含空格',
		hangyeRules:'请选择所属行业',
		lianxidianhua:'联系电话',
		chuanzhen:'传真',
		LianXiRenZhiWu:'联系人职务',
		LianXiRenEmail:'联系人E-mail',
		ChePaiHao:'车牌号',
		AddChePaiHao:'添加车牌号',
		LianLuoXinxiWhetherPublic:'联络信息是否公开',
		BeiZhu:'备注',
		emil:'E-mail地址',
		LianXiRenName:'联系人姓名',
		LianXiRenPhone:'联系人电话',
		YouBian:'邮编',
		TongXun:'即时通讯',
		WhetherInterview:'是否接受采访',
		yes:'是',
		no:'否',
		lianxidianhuaRules:'请输入联系电话',
		emilRules:'请输入E-mail地址',
		chuanzhenRules:'请输入传真号码',
		LianXiRenNameRules:'请输入联系人姓名',
		LianXiRenZhiWuRules:'请输入联系人职务',
		LianXiRenPhoneRules:'请输入联系人电话',
		LianXiRenEmailRules:'请输入联系人E-mail',
		YouBianRules:'请输入邮编',
		ChePaiHaoRules:'请务必分清楚0和O，如果错误将无法正常使用',
		TongXunRules:'最多200个字',
		phoneRulesError:'请输入正确的手机号格式',
		emilRulesError:'请输入正确的邮箱格式',
		infoConfirm:'信息确认',
		submitPrompt:'提交前请仔细检查，提交后数据无法修改',
		Review:'检查',

		"viwers":"人观看",
		"noMore":"已经底部了",
		"type":"类型",
		"nameCn_tips":"请输入中文名称",
		"nameEn_tips":"请输入英文名称",
		"nameEn_tips1":"请输入英文名称（若无，请写“无”）",
		"area":"签发国家或地区",
		"address_tip":"请输入详细地址",
		"address_tip2":"请输入所在街道",
		"cerType":"身份证件类型",
		"cerCode":"证件号码",
		"cerCode_tips":"请输入证件号码",
		"cerCode_tips2":"证件号码有误",
		"birth":"出生日期",
		"date_tips":"选择日期",
		"nick":"称谓",
		"head":"头像上传",
		"idCard":"证件上传",
		"mod_1":"个人信息",
		"mod_2":"机构信息",
		"mod_3":"联络信息",
		"industry":"所属行业",
		"select_tips":"请选择",
		"orgCn":"公司名称（中文全称）",
		"orgCn_tips":"请输入公司中文全称",
		"orgEn":"公司名称（英文全称)",
		"orgEn_tips":"请输入公司英文全称",
		"orgEn_tips1":"请输入公司英文全称（若无，请写“无”）",
		"orgAddr":"机构地址",
		"orgAddr_tips":"请输入机构地址",
		"orgAddr_tips1":"请输入机构地址（若无，请写“无”）",
		"position":"职务",
		"position_tips":"请输入职务",
		"orgSimpleCn":"机构简称（中文）",
		"orgSimpleCn_tips":"最多8个文字",
		"orgSimpleEn":"机构简称（英文）",
		"orgSimpleEn_tips":"最多20个字母包含空格",
		"phone":"手机号",
		"phone_tips":"请输入联系电话",
		"phone_tips2":"联系电话输入有误",
		"email":"邮箱",
		"email_tips":"请输入邮箱",
		"email_tips2":"邮箱地址有误",
		"fax":"传真号码",
		"fax_tips":"请输入传真号码",
		"iName": "联系人姓名",
		"iName_tips":"请输入联系人姓名",
		"iPosition":"联系人职务",
		"iPosition_tips": "请输入联系人职务",
		"iPhone":"联系人电话",
		"iPhone_tips":"请输入联系人电话",
		"iEmail":"联系人E-mail",
		"iEmail_tips":"请输入联系人E-mail",
		"postcode":"邮编",
		"postcode_tips":"请输入邮编",
		"plate":"车牌号",
		"plate_tips":"请务必分清o和0、如果错误将无法正常使用",
		"plate_tips2":"车牌输入有误",
		"plateAdd":"添加车牌号",
		"im":"即时通讯",
		"im_tips": "最多200个文字",
		"open":"联络信息是否公开",
		"interview":"是否接受采访",
		"remarks":"备注",
		"prev":"上一步",
		"next":"下一步",
		"yes":"是",
		"no":"否",
		"ok":"确定",
		"back":"返回修改",
		"submit":"提交",
		"confirm":"确认提交",
		"confirm2":"确认提交",
		"confirm_tips":"提交前请仔细检查、提交后数据无法修改",
		"check":"检查",
		"success":"报名信息提交成功!",
		"uploadSuccess":"上传成功！",
		"uploadFailed":"上传失败！",
		"upload_tips":"请上传",
		ConfirmSubmit:'确认提交',
		applySuccess:'报名信息提交成功!',
		shenfenzhengError:'身份证格式错误',
		zhengwentabs:['征文通知'],
		submitPrompt:'提交前请仔细检查，提交后数据无法修改',
		infoConfirm:"信息确认",
		"getBack":"返回修改",
		"Review":"检查",
		"applySuccess":"报名信息提交成功,请耐心等待工作人员审核",
		"join":"参加",
		"unjoin":"不参加",
		"appointmentTitle":"参会场次"
	},
	applyJourney:{
		ji_ben_xin_xi: '基本信息',
		hui_yi_jiu_dian_xin_xi: '会议酒店信息',
		title:'来程信息',
		chu_fa_di:'出发地',
		di_zhi: '地址',
		jiudian: '长沙市解放东路300号华天大酒店',
		ding_fang_dian_hua: '订房电话',
		xiang_xi_di_zhi:'详细地址',
		di_da_zhan_dian:'抵达站点',
		di_da_ri_qi:'抵达日期',
		fan_chen_xin_xi:'返程信息',
		jiao_tong_gong_ju:'交通工具',
		fan_chen_hang_ban:'返程航班/高铁',
		di_da_hang_ban:'抵达航班/高铁',
		fan_chen_zhan_dian:'返程站点',
		fan_chen_ri_qi:'返程日期',
		dizhi:'城市',
		xuanze_riqi:'选择日期',
		xiang_xi_di_zhi_rules:'请输入详细地址',
		di_da_hang_ban_rules:'请输入抵达航班',
		fan_chen_hang_ban_rules:'请输入返程航班',
		hang_ban_rules:'请输入航班，填写班次即可，如“FM9853”',
		// submitSucceed:'行程信息提交成功，如要修改可继续提交最新行程信息',
		submitSucceed:'行程信息提交成功',
		inform:'请在参会前填写好行程信息，否则将影响参会',
		bao_ming_ren_yuan:'报名人员',
		shouji:'手机号码',
		bao_ming:'参会报名',
		registration_ends:'报名结束',
		zhu_su_xin_xi:'住宿信息',
		shi_fou_xu_yao_zhu_su:'是否需要住宿',
		fang_xing:'房型',
		fu_fei_qing_kuang:'付费情况',
		ru_zhu_shi_jian:'入住时间',
		li_dian_shi_jian:'离店时间',
		shi_fou_xu_yao_jie_ji:'是否需要接送机/站',
		di_da_shi_jian:'抵达时间',
		fan_chen_shi_jian:'返程时间',
		bei_zhu:'备注',
		xuan_ze_shi_jian:'选择时间',
		jie_dao:'请输入所在街道',
		shu_ru_bei_zhu:'请输入备注信息',
		lun_tan_guan_wang:'论坛官网'
	},
	applyHealth: {
		bigTitle: "个人健康信息申报卡",
		title1: "1、近28天是否有境外或港台地区旅居史? ",
		title11: "如有请注明国家(地区)：",
		title12: "入境时间：",
		title2: "2、近14天是否有境内中高风险地区旅居史?",
		title3: "3、近14天是否有境内中高风险地区所在城市旅居史（11月28日起）?",
		title31: "如有请注明城市：",
		title32: "最后离开风险地区所在城市的时间为：",
		title4: "4、近14天是否接触过来自中高风险地区的亲属、朋友?",
		title5: "5、近14天是否接触过可疑病例及发热病人?",
		title6: "6、近14天是否有家人、朋友发热或患肺炎等疾病?",
		title7: "7、是否曾经诊断为新冠肺炎病例、无症状感染者?",
		title8: "8、近14天您本人是否有如下症状?",
		"无": "无",
		"发热": "发热",
		"咳嗽": "咳嗽",
		"寒战": "寒战",
		"鼻塞": "鼻塞",
		"流涕": "流涕",
		"咽痛": "咽痛",
		"头痛": "头痛",
		"嗅（味）觉减退": "嗅（味）觉减退",
		"乏力": "乏力",
		"肌肉酸痛": "肌肉酸痛",
		"关节酸痛": "关节酸痛",
		"胸闷": "胸闷",
		"气促呼吸困难": "气促呼吸困难",
		"结膜充血": "结膜充血",
		"恶心": "恶心",
		"呕吐": "呕吐",
		"腹泻": "腹泻",
		"腹痛": "腹痛",
		title81: "或有其他需要说明的身体不适症状",
		title9: "9、请会议注册时提供抵长沙前48小时内核酸检测阴性证明(12月14—15日内)",
		"阴性": "阴性",
		"阳性": "阳性",
		title91: "检测日期",
		title10: "10、健康码",
		"绿色": "绿色",
		"黄色": "黄色",
		"红色": "红色",
		title101: " 11、行程码",
		title1011: "无带“*”城市旅居史",
		title1012: "带“*”城市旅居史",
		fill1: "填表人（签字）：",
		fill2: "填写日期：",
		"tips1": "本人承诺：如实填写上述内容，自觉履行疫情防控的法律法规义务，承担相应的法律法规责任。",
		"tips2": "经核，本人均无上述相关情况",
		"confirm":"请勾选核实信息选框！",
		"pleaseFill":"请填写"
	},
	agendaTitle: '论坛议程',
	expertTitle: '专家访谈',
	pastVideoTitle: '往届精彩回顾',
	forumTitle: '关于论坛',
	HostByTitle: '主办单位',
	OrganizedByTitle: '承办单位',
	ExecutivePartiesTitle: '执行承办单位',
	OperatingPartiesTitle: '执行单位',
	CoOrganizedPartiesTitle: '协办单位',
	SpecialAcknowledgementTitle: '特别鸣谢',
}
